export enum EnrollmentSuccessType {
  CREATED = "created",
  TRANSITIONED = "transitioned",
  UPGRADED = "upgraded",
}
